<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.dashboards')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-row class="icon-cards-row mb-3">
          <b-colxx xxs="6" sm="4" md="3" lg="2">
            <icon-card
              :title="$t('menu.blogs')"
              icon="iconsminds-pantone"
              :value="sizeBlogs"
            />
          </b-colxx>
          <b-colxx xxs="6" sm="4" md="3" lg="2">
            <icon-card
              :title="$t('menu.bio')"
              icon="iconsminds-diploma-2"
              :value="sizeBiography"
            />
          </b-colxx>
          <b-colxx xxs="6" sm="4" md="3" lg="2">
            <icon-card
              :title="$t('menu.videos')"
              icon="iconsminds-video"
              :value="sizeVideos"
            />
          </b-colxx>
          <b-colxx xxs="6" sm="4" md="3" lg="2">
            <icon-card
              :title="$t('menu.gallery')"
              icon="iconsminds-photo-album-2"
              :value="sizeGallery"
            />
          </b-colxx>
        </b-row>
      </b-colxx>
    </b-row>

  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import IconCard from "../../../components/Cards/IconCard";

export default {
  components: {
    "icon-card": IconCard
  },
  data() {
    return {
      sizeBlogs: 0,
      sizeBiography: 0,
      sizeVideos: 0,
      sizeGallery: 0
    };
  },
  methods: {
    loadItems() {
      db.collection("blogs")
        .get()
        .then(querySnapshop => {
          console.log("Blogs size:", querySnapshop.size);
          this.sizeBlogs = querySnapshop.size;
        });
      db.collection("biography")
        .get()
        .then(querySnapshop => {
          console.log("biography size:", querySnapshop.size);
          this.sizeBiography = querySnapshop.size;
        });
      db.collection("videos")
        .get()
        .then(querySnapshop => {
          console.log("Blogs size:", querySnapshop.size);
          this.sizeVideos = querySnapshop.size;
        });
      db.collection("gallery")
        .get()
        .then(querySnapshop => {
          console.log("gallery size:", querySnapshop.size);
          this.sizeGallery = querySnapshop.size;
        });
    }
  },
  mounted() {
    this.loadItems();
  }
};
</script>
